/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { UserSearchResultsDto } from '../../models/user-search-results-dto';

export interface AdminSearchUsers$Params {
  first_name?: string;
  last_name?: string;
  organisation?: string;
  email?: string;
  roles?: Array<string>;
  requests_only?: boolean;
}

export function adminSearchUsers(
  http: HttpClient,
  rootUrl: string,
  params?: AdminSearchUsers$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<UserSearchResultsDto>> {
  const rb = new RequestBuilder(rootUrl, adminSearchUsers.PATH, 'get');
  if (params) {
    rb.query('first_name', params.first_name, {});
    rb.query('last_name', params.last_name, {});
    rb.query('organisation', params.organisation, {});
    rb.query('email', params.email, {});
    rb.query('roles', params.roles, {});
    rb.query('requests_only', params.requests_only, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserSearchResultsDto>;
      }),
    );
}

adminSearchUsers.PATH = '/admin/users';
